(() => {
  const initialise = (root) => {
    if (root.dataset.alkReady === 'true') return;
    root.dataset.alkReady = 'true';

    const media = JSON.parse(root.querySelector('[data-alk-media-json]')?.textContent || '[]');
    const heroImage = root.querySelector('[data-alk-hero-image]');
    const dialog = root.querySelector('[data-alk-dialog]');
    const dialogImage = root.querySelector('[data-alk-dialog-image]');
    const dialogCount = root.querySelector('[data-alk-dialog-count]');
    const countLabels = root.querySelectorAll('[data-alk-count]');
    const mainMedia = root.querySelector('.alk-proto-main-media');
    const mediaOpen = root.querySelector('.alk-proto-media-open');
    const mainButton = root.querySelector('#AlkPdpPrimaryButton');
    const returnButton = root.querySelector('[data-alk-return]');
    const requestSimilarButton = root.querySelector('[data-alk-request-similar]');
    const sticky = root.querySelector('[data-alk-sticky]');
    const isMobileCompressed = root.classList.contains('alk-proto--mobile-compressed');
    let currentIndex = Number(root.dataset.alkInitialIndex || 0);
    let touchStartX = 0;
    let touchStartY = 0;
    let touchDeltaX = 0;
    let touchDeltaY = 0;
    let trackingTouch = false;
    let horizontalGesture = false;
    let suppressHeroOpen = false;

    if (isMobileCompressed && window.matchMedia('(max-width: 900px)').matches) {
      root.querySelectorAll('.alk-proto-practical details').forEach((details) => { details.open = false; });
    }

    const padded = (value) => String(value).padStart(2, '0');
    const setMedia = (index) => {
      if (!media.length) return;
      currentIndex = (Number(index) + media.length) % media.length;
      const item = media[currentIndex];
      if (heroImage) {
        heroImage.src = item.src;
        heroImage.alt = item.alt;
      }
      if (dialogImage) {
        dialogImage.src = item.src;
        dialogImage.alt = item.alt;
      }
      countLabels.forEach((label) => { label.textContent = `${root.querySelector('[data-alk-view-label]')?.textContent || 'View'} ${padded(currentIndex + 1)} / ${padded(media.length)}`; });
      if (dialogCount) dialogCount.textContent = `${root.querySelector('[data-alk-view-label]')?.textContent || 'View'} ${padded(currentIndex + 1)} / ${padded(media.length)}`;
      root.querySelectorAll('[data-alk-media]').forEach((button) => {
        if (Number(button.dataset.index) === currentIndex) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    };

    root.querySelectorAll('[data-alk-media]').forEach((button) => {
      button.addEventListener('click', () => setMedia(button.dataset.index));
    });
    root.querySelectorAll('[data-alk-prev]').forEach((button) => button.addEventListener('click', () => setMedia(currentIndex - 1)));
    root.querySelectorAll('[data-alk-next]').forEach((button) => button.addEventListener('click', () => setMedia(currentIndex + 1)));
    root.querySelectorAll('[data-alk-open]').forEach((button) => button.addEventListener('click', () => {
      if (button === mediaOpen && suppressHeroOpen) {
        suppressHeroOpen = false;
        return;
      }
      setMedia(currentIndex);
      dialog?.showModal();
    }));

    if (mainMedia && media.length > 1) {
      mainMedia.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return;
        const touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchDeltaX = 0;
        touchDeltaY = 0;
        trackingTouch = true;
        horizontalGesture = false;
      }, { passive: true });

      mainMedia.addEventListener('touchmove', (event) => {
        if (!trackingTouch || event.touches.length !== 1) return;
        const touch = event.touches[0];
        touchDeltaX = touch.clientX - touchStartX;
        touchDeltaY = touch.clientY - touchStartY;
        if (Math.abs(touchDeltaX) > 10 && Math.abs(touchDeltaX) > Math.abs(touchDeltaY) * 1.15) {
          horizontalGesture = true;
          event.preventDefault();
        }
      }, { passive: false });

      mainMedia.addEventListener('touchend', () => {
        if (!trackingTouch) return;
        trackingTouch = false;
        if (!horizontalGesture) return;
        suppressHeroOpen = true;
        if (Math.abs(touchDeltaX) >= 42) setMedia(currentIndex + (touchDeltaX < 0 ? 1 : -1));
        window.setTimeout(() => { suppressHeroOpen = false; }, 350);
      }, { passive: true });

      mainMedia.addEventListener('touchcancel', () => {
        trackingTouch = false;
        horizontalGesture = false;
      }, { passive: true });
    }
    root.querySelector('[data-alk-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

    const submitMainForm = () => mainButton?.click();
    returnButton?.addEventListener('click', submitMainForm);
    root.querySelector('[data-alk-sticky-submit]')?.addEventListener('click', submitMainForm);
    requestSimilarButton?.addEventListener('click', () => {
      if (typeof window.openManifestModal !== 'function') return;
      window.openManifestModal(
        requestSimilarButton.dataset.manifestTitle,
        requestSimilarButton.dataset.manifestHandle,
        requestSimilarButton.dataset.manifestUrl,
        requestSimilarButton.dataset.manifestPrice,
        requestSimilarButton.dataset.manifestImage,
        requestSimilarButton.dataset.manifestRelatedHandles || '',
        'sold_pdp'
      );
    });

    const updateSticky = () => {
      if (!sticky || !mainButton) return;
      const mainPassed = mainButton.getBoundingClientRect().bottom < 0;
      const returnVisible = returnButton
        ? returnButton.getBoundingClientRect().top < window.innerHeight && returnButton.getBoundingClientRect().bottom > 0
        : false;
      sticky.hidden = !(mainPassed && !returnVisible);
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
  };

  const initialiseAll = () => document.querySelectorAll('[data-alk-pdp]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
